// CPI-979: helpers for the MHub Pay (MPW) online-gateway redirect flow (CRM).
// Mirrors marketplace-web's src/utils/payment.ts, adapted to leads-v2-web.

import { isValidHttpUrl } from './url';

/**
 * The return URL we ask book-api to register as MPA's client_return_url — where
 * MPW sends the buyer after paying. We land them straight back on the opportunity's
 * booking page; book-api settles the payment status from the MPA webhook.
 */
export function buildPaymentReturnUrl(opportunityId) {
  const base = `${window.location.origin}/opportunities`;
  return opportunityId ? `${base}/${opportunityId}/booking` : base;
}

/** Full-page redirect to the MPW checkout page. */
export function redirectToCheckout(checkoutUrl) {
  if (!isValidHttpUrl(checkoutUrl)) {
    throw new Error('Invalid checkout URL');
  }
  window.location.href = checkoutUrl;
}
